import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import Loader from "atoms/loaders/loader";
import Paragraph from "atoms/typography/paragraph";
import { ModalTypes } from "molecules/constants/modal-types";
import Modal from "molecules/modals/modal";
import DemoPrintFooter from "pages/demos/layout-components/demo-print-footer";
import DemoPrintHeader from "pages/demos/layout-components/demo-print-header";
import React from "react";
import { PropsWithChildren } from "react";
import useNfpaPdf from "utilities/hooks/domain/printing/use-nfpa-pdf";

const CSS_CLASS_NAME = "c-printable";

interface DownloadableAltProps extends PropsWithChildren {
    header?: JSX.Element;
    footer?: JSX.Element;
}

const Downloadable = ({ children, header, footer }: DownloadableAltProps) => {
    const { onGeneratePdf, isGenerating } = useNfpaPdf({ name: "demo" });
    return (
        <>
            <div className={CSS_CLASS_NAME}>
                <Button
                    style={ButtonStyles.Secondary}
                    cssClassName={`${CSS_CLASS_NAME}__printButton`}
                    onClick={onGeneratePdf}>
                    {isGenerating ? "Loading..." : "Download PDF"}
                </Button>
                <table className={`${CSS_CLASS_NAME}__table`}>
                    <thead>
                        <tr>
                            <td>
                                <div
                                    className={`${CSS_CLASS_NAME}__headerSpace`}
                                />
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <main className={`${CSS_CLASS_NAME}__content`}>
                                    {children}
                                </main>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>
                                <div
                                    className={`${CSS_CLASS_NAME}__footerSpace`}>
                                    <footer
                                        className={`${CSS_CLASS_NAME}__footer`}>
                                        {footer ?? <DemoPrintFooter />}
                                    </footer>
                                </div>
                            </th>
                        </tr>
                    </tfoot>
                </table>
                <header className={`${CSS_CLASS_NAME}__header`}>
                    {header ?? <DemoPrintHeader />}
                </header>
            </div>
            {/* Change to progress Toast so user can move about the app while generation finishes */}
            <Modal
                cssClassName={`${CSS_CLASS_NAME}__modal`}
                closeDialog={() => {}}
                isVisible={isGenerating}
                label={""}
                type={ModalTypes.Base}>
                <Loader />
                <Paragraph>Generating PDF</Paragraph>
            </Modal>
        </>
    );
};

export default Downloadable;
